(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-form-test"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ext-form-wrap]').forEach(function (wrap) {
      var form = wrap.querySelector('form.ext-upload-form__form');
      if (form) initExtUploadForm(form);
    });

    function initExtUploadForm(form) {
      var productRows = form.querySelectorAll('[data-ext-product]');
      var productsOutput = form.querySelector('[data-ext-products-output]');
      var productError = form.querySelector('[data-ext-product-error]');
      var requireProducts = form.getAttribute('data-ext-require-products') === 'true';

      var customizationType = form.querySelector('[data-customization-type]');
      var heatWrap = form.querySelector('[data-heat-wrap]');
      var embroideryWrap = form.querySelector('[data-embroidery-wrap]');

      function setPositionGroup(wrap, isOpen) {
        if (!wrap) return;

        var radios = wrap.querySelectorAll('input[type="radio"]');

        wrap.hidden = !isOpen;

        radios.forEach(function (radio) {
          radio.required = isOpen;

          if (!isOpen) {
            radio.checked = false;
          }
        });
      }

      function togglePositionFields() {
        if (!customizationType) return;

        var value = customizationType.value;

        setPositionGroup(heatWrap, value === 'Heat Pressing');
        setPositionGroup(embroideryWrap, value === 'Embroidery');
      }

      if (customizationType) {
        customizationType.addEventListener('change', togglePositionFields);
        togglePositionFields();
      }

      productRows.forEach(function (row) {
        var checkbox = row.querySelector('[data-ext-product-checkbox]');
        var qty = row.querySelector('[data-ext-product-qty]');

        if (!checkbox || !qty) return;

        checkbox.addEventListener('change', function () {
          row.classList.toggle('is-selected', checkbox.checked);
          qty.disabled = !checkbox.checked;

          if (checkbox.checked) {
            if (!qty.value) qty.value = 1;
            qty.focus();
          } else {
            qty.value = '';
          }

          compileProducts();
        });

        qty.addEventListener('input', compileProducts);
      });

      function compileProducts() {
        if (!productsOutput) return;

        var lines = [];

        productRows.forEach(function (row) {
          var cb = row.querySelector('[data-ext-product-checkbox]');
          var qty = row.querySelector('[data-ext-product-qty]');

          if (cb && cb.checked) {
            var name = cb.getAttribute('data-ext-product-name') || '';
            var sku = cb.getAttribute('data-ext-product-sku') || '';
            var price = cb.getAttribute('data-ext-product-price') || '';
            var q = qty && qty.value ? qty.value : '';

            var skuPart = sku ? ' (SKU: ' + sku + ')' : '';
            var pricePart = price ? ' @ ' + price + ' ea.' : '';

            lines.push('- ' + name + skuPart + pricePart + ' — Qty: ' + q);
          }
        });

        productsOutput.value = lines.length ? '\n' + lines.join('\n') : '';
      }

      form.addEventListener('submit', function (e) {
        togglePositionFields();
        compileProducts();

        if (!requireProducts || productRows.length === 0) {
          if (productError) productError.hidden = true;
          return;
        }

        var anySelected = false;
        var allHaveQty = true;

        productRows.forEach(function (row) {
          var cb = row.querySelector('[data-ext-product-checkbox]');
          var qty = row.querySelector('[data-ext-product-qty]');

          if (cb && cb.checked) {
            anySelected = true;

            if (!qty || !qty.value || parseInt(qty.value, 10) < 1) {
              allHaveQty = false;
            }
          }
        });

        if (!anySelected || !allHaveQty) {
          e.preventDefault();

          if (productError) {
            productError.hidden = false;
            productError.textContent = !anySelected
              ? 'Please select at least one product.'
              : 'Please enter a quantity of 1 or more for each selected product.';
          }

          var list = form.querySelector('[data-ext-products]');

          if (list) {
            list.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          return;
        }

        if (productError) productError.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ppg-form"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[data-ppg-form-wrap]').forEach(function (wrap) {
        var form = wrap.querySelector('form.ppg-form');
        if (form) initPpgForm(form);
      });

      function initPpgForm(form) {
        function setConditionalPanelOpen(panel, isOpen) {
          var key = panel.getAttribute('data-ppg-conditional');
          if (!key) return;
          panel.classList.toggle('is-open', isOpen);
          if (!isOpen) {
            panel.querySelectorAll('[data-ppg-required-when="' + key + '"]').forEach(function (field) {
              field.removeAttribute('required');
              if (field.tagName === 'SELECT') field.value = '';
              else field.value = '';
            });
            if (key === 'training') {
              panel.querySelectorAll('[data-ppg-training-checkbox]').forEach(function (cb) {
                cb.checked = false;
                var trainRow = cb.closest('[data-ppg-training-product]');
                if (trainRow) trainRow.classList.remove('is-selected');
              });
              var trainOut = panel.querySelector('[data-ppg-training-output]');
              if (trainOut) trainOut.value = '';
            }
          }
          panel.querySelectorAll('input, select, textarea').forEach(function (field) {
            field.disabled = !isOpen;
          });
          if (isOpen) {
            panel.querySelectorAll('[data-ppg-required-when="' + key + '"]').forEach(function (field) {
              field.setAttribute('required', '');
            });
          }
        }

        function syncAllConditionalPanels() {
          form.querySelectorAll('[data-ppg-conditional]').forEach(function (panel) {
            setConditionalPanelOpen(panel, panel.classList.contains('is-open'));
          });
        }

        // ===== Conditional toggles (CERTS / Training) =====
        form.querySelectorAll('[data-ppg-toggle]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            var key = radio.getAttribute('data-ppg-toggle');
            var panel = form.querySelector('[data-ppg-conditional="' + key + '"]');
            if (!panel) return;
            var isYes = radio.value === 'Yes' && radio.checked;
            setConditionalPanelOpen(panel, isYes);
          });
        });

        form.querySelectorAll('[data-ppg-conditional]').forEach(function (panel) {
          setConditionalPanelOpen(panel, panel.classList.contains('is-open'));
        });

        // ===== Product multi-select with per-product qty =====
        var productRows = form.querySelectorAll('[data-ppg-product]');
        var productsOutput = form.querySelector('[data-ppg-products-output]');
        var productError = form.querySelector('[data-ppg-product-error]');

        productRows.forEach(function (row) {
          var checkbox = row.querySelector('[data-ppg-product-checkbox]');
          var qty = row.querySelector('[data-ppg-product-qty]');
          if (!checkbox || !qty) return;

          checkbox.addEventListener('change', function () {
            row.classList.toggle('is-selected', checkbox.checked);
            qty.disabled = !checkbox.checked;
            if (checkbox.checked) {
              if (!qty.value) qty.value = 1;
              qty.focus();
            } else {
              qty.value = '';
            }
            compileProducts();
          });

          qty.addEventListener('input', compileProducts);
        });

        function compileProducts() {
          if (!productsOutput) return;
          var lines = [];
          productRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-product-checkbox]');
            var qty = row.querySelector('[data-ppg-product-qty]');
            if (cb && cb.checked) {
              var name = cb.getAttribute('data-ppg-product-name') || '';
              var sku = cb.getAttribute('data-ppg-product-sku') || '';
              var price = cb.getAttribute('data-ppg-product-price') || '';
              var q = (qty && qty.value) ? qty.value : '';
              var skuPart = sku ? ' (SKU: ' + sku + ')' : '';
              var pricePart = price ? ' @ ' + price + ' ea.' : '';
              lines.push('- ' + name + skuPart + pricePart + ' — Qty: ' + q);
            }
          });
          productsOutput.value = lines.length ? '\n' + lines.join('\n') : '';
        }

        // ===== Training products: multi-select, no qty/price =====
        var trainingRows = form.querySelectorAll('[data-ppg-training-product]');
        var trainingOutput = form.querySelector('[data-ppg-training-output]');
        var trainingError = form.querySelector('[data-ppg-training-product-error]');

        trainingRows.forEach(function (row) {
          var cb = row.querySelector('[data-ppg-training-checkbox]');
          if (!cb) return;
          cb.addEventListener('change', function () {
            row.classList.toggle('is-selected', cb.checked);
            compileTrainingProducts();
          });
        });

        function compileTrainingProducts() {
          if (!trainingOutput) return;
          if (trainingOutput.disabled) {
            trainingOutput.value = '';
            return;
          }
          var lines = [];
          trainingRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-training-checkbox]');
            if (cb && cb.checked) {
              var name = cb.getAttribute('data-ppg-training-name') || '';
              lines.push('- ' + name);
            }
          });
          trainingOutput.value = lines.length ? '\n' + lines.join('\n') : '';
        }

        // ===== Submit validation: at least one product + qty =====
        form.addEventListener('submit', function (e) {
          var honeypot = form.querySelector('[data-ppg-honeypot]');
          if (honeypot && honeypot.value) {
            e.preventDefault();
            return;
          }
          syncAllConditionalPanels();
          compileProducts();
          compileTrainingProducts();
          var anySelected = false;
          var allHaveQty = true;
          productRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-product-checkbox]');
            var qty = row.querySelector('[data-ppg-product-qty]');
            if (cb && cb.checked) {
              anySelected = true;
              if (!qty || !qty.value || parseInt(qty.value, 10) < 1) allHaveQty = false;
            }
          });
          if (!anySelected || !allHaveQty) {
            e.preventDefault();
            if (productError) {
              productError.style.display = 'block';
              productError.textContent = !anySelected
                ? 'Please select at least one product.'
                : 'Please enter a quantity (1 or more) for each selected product.';
            }
            if (trainingError) trainingError.style.display = 'none';
            var firstProduct = form.querySelector('[data-ppg-products]');
            if (firstProduct) firstProduct.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (productError) {
            productError.style.display = 'none';
          }

          var trainingReq = form.querySelector('input[name="contact[Training requested]"]:checked');
          if (trainingReq && trainingReq.value === 'Yes' && trainingRows.length > 0) {
            compileTrainingProducts();
            var anyTraining = false;
            trainingRows.forEach(function (row) {
              var cb = row.querySelector('[data-ppg-training-checkbox]');
              if (cb && cb.checked) anyTraining = true;
            });
            if (!anyTraining) {
              e.preventDefault();
              if (trainingError) {
                trainingError.style.display = 'block';
              }
              var trainingList = form.querySelector('[data-ppg-training-products]');
              if (trainingList) trainingList.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (trainingError) {
              trainingError.style.display = 'none';
            }
          } else if (trainingError) {
            trainingError.style.display = 'none';
          }
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sign-posts-form"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[data-ppg-form-wrap]').forEach(function (wrap) {
        var form = wrap.querySelector('form.ppg-form');
        if (form) initPpgForm(form);
      });

      function initPpgForm(form) {
        function setConditionalPanelOpen(panel, isOpen) {
          var key = panel.getAttribute('data-ppg-conditional');
          if (!key) return;
          panel.classList.toggle('is-open', isOpen);
          if (!isOpen) {
            panel.querySelectorAll('[data-ppg-required-when="' + key + '"]').forEach(function (field) {
              field.removeAttribute('required');
              if (field.tagName === 'SELECT') field.value = '';
              else field.value = '';
            });
            if (key === 'training') {
              panel.querySelectorAll('[data-ppg-training-checkbox]').forEach(function (cb) {
                cb.checked = false;
                var trainRow = cb.closest('[data-ppg-training-product]');
                if (trainRow) trainRow.classList.remove('is-selected');
              });
              var trainOut = panel.querySelector('[data-ppg-training-output]');
              if (trainOut) trainOut.value = '';
            }
          }
          panel.querySelectorAll('input, select, textarea').forEach(function (field) {
            field.disabled = !isOpen;
          });
          if (isOpen) {
            panel.querySelectorAll('[data-ppg-required-when="' + key + '"]').forEach(function (field) {
              field.setAttribute('required', '');
            });
          }
        }

        function syncAllConditionalPanels() {
          form.querySelectorAll('[data-ppg-conditional]').forEach(function (panel) {
            setConditionalPanelOpen(panel, panel.classList.contains('is-open'));
          });
        }

        // ===== Conditional toggles (CERTS / Training) =====
        form.querySelectorAll('[data-ppg-toggle]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            var key = radio.getAttribute('data-ppg-toggle');
            var panel = form.querySelector('[data-ppg-conditional="' + key + '"]');
            if (!panel) return;
            var isYes = radio.value === 'Yes' && radio.checked;
            setConditionalPanelOpen(panel, isYes);
          });
        });

        form.querySelectorAll('[data-ppg-conditional]').forEach(function (panel) {
          setConditionalPanelOpen(panel, panel.classList.contains('is-open'));
        });

        // ===== Product multi-select with per-product qty =====
        var productRows = form.querySelectorAll('[data-ppg-product]');
        var productsOutput = form.querySelector('[data-ppg-products-output]');
        var productError = form.querySelector('[data-ppg-product-error]');

        productRows.forEach(function (row) {
          var checkbox = row.querySelector('[data-ppg-product-checkbox]');
          var qty = row.querySelector('[data-ppg-product-qty]');
          if (!checkbox || !qty) return;

          checkbox.addEventListener('change', function () {
            row.classList.toggle('is-selected', checkbox.checked);
            qty.disabled = !checkbox.checked;
            if (checkbox.checked) {
              if (!qty.value) qty.value = 1;
              qty.focus();
            } else {
              qty.value = '';
            }
            compileProducts();
          });

          qty.addEventListener('input', compileProducts);
        });

        function compileProducts() {
          if (!productsOutput) return;
          var lines = [];
          productRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-product-checkbox]');
            var qty = row.querySelector('[data-ppg-product-qty]');
            if (cb && cb.checked) {
              var name = cb.getAttribute('data-ppg-product-name') || '';
              var sku = cb.getAttribute('data-ppg-product-sku') || '';
              var price = cb.getAttribute('data-ppg-product-price') || '';
              var q = (qty && qty.value) ? qty.value : '';
              var skuPart = sku ? ' (SKU: ' + sku + ')' : '';
              var pricePart = price ? ' @ ' + price + ' ea.' : '';
              lines.push('- ' + name + skuPart + pricePart + ' — Qty: ' + q);
            }
          });
          productsOutput.value = lines.length ? '\n' + lines.join('\n') : '';
        }

        // ===== Training products: multi-select, no qty/price =====
        var trainingRows = form.querySelectorAll('[data-ppg-training-product]');
        var trainingOutput = form.querySelector('[data-ppg-training-output]');
        var trainingError = form.querySelector('[data-ppg-training-product-error]');

        trainingRows.forEach(function (row) {
          var cb = row.querySelector('[data-ppg-training-checkbox]');
          if (!cb) return;
          cb.addEventListener('change', function () {
            row.classList.toggle('is-selected', cb.checked);
            compileTrainingProducts();
          });
        });

        function compileTrainingProducts() {
          if (!trainingOutput) return;
          if (trainingOutput.disabled) {
            trainingOutput.value = '';
            return;
          }
          var lines = [];
          trainingRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-training-checkbox]');
            if (cb && cb.checked) {
              var name = cb.getAttribute('data-ppg-training-name') || '';
              lines.push('- ' + name);
            }
          });
          trainingOutput.value = lines.length ? '\n' + lines.join('\n') : '';
        }

        // ===== Submit validation: at least one product + qty =====
        form.addEventListener('submit', function (e) {
          var honeypot = form.querySelector('[data-ppg-honeypot]');
          if (honeypot && honeypot.value) {
            e.preventDefault();
            return;
          }
          syncAllConditionalPanels();
          compileProducts();
          compileTrainingProducts();
          var anySelected = false;
          var allHaveQty = true;
          productRows.forEach(function (row) {
            var cb = row.querySelector('[data-ppg-product-checkbox]');
            var qty = row.querySelector('[data-ppg-product-qty]');
            if (cb && cb.checked) {
              anySelected = true;
              if (!qty || !qty.value || parseInt(qty.value, 10) < 1) allHaveQty = false;
            }
          });
          if (!anySelected || !allHaveQty) {
            e.preventDefault();
            if (productError) {
              productError.style.display = 'block';
              productError.textContent = !anySelected
                ? 'Please select at least one product.'
                : 'Please enter a quantity (1 or more) for each selected product.';
            }
            if (trainingError) trainingError.style.display = 'none';
            var firstProduct = form.querySelector('[data-ppg-products]');
            if (firstProduct) firstProduct.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (productError) {
            productError.style.display = 'none';
          }

          var trainingReq = form.querySelector('input[name="contact[Training requested]"]:checked');
          if (trainingReq && trainingReq.value === 'Yes' && trainingRows.length > 0) {
            compileTrainingProducts();
            var anyTraining = false;
            trainingRows.forEach(function (row) {
              var cb = row.querySelector('[data-ppg-training-checkbox]');
              if (cb && cb.checked) anyTraining = true;
            });
            if (!anyTraining) {
              e.preventDefault();
              if (trainingError) {
                trainingError.style.display = 'block';
              }
              var trainingList = form.querySelector('[data-ppg-training-products]');
              if (trainingList) trainingList.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (trainingError) {
              trainingError.style.display = 'none';
            }
          } else if (trainingError) {
            trainingError.style.display = 'none';
          }
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
